var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOutputLight = function SvgIconOutputLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.133 8.467c-.928 0-1.666.738-1.666 1.666v12.534c0 .928.738 1.666 1.666 1.666h12.534c.928 0 1.666-.738 1.666-1.666v-.934H25.8v.934a3.123 3.123 0 0 1-3.133 3.133H10.133A3.123 3.123 0 0 1 7 22.667V10.133A3.123 3.123 0 0 1 10.133 7h12.534a3.123 3.123 0 0 1 3.133 3.133v.934h-1.467v-.934c0-.928-.738-1.666-1.666-1.666H10.133Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 17.134H14.333v-1.466H25v1.466Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.285 16.324-3.856-3.657 1.009-1.064 3.867 3.667.014.013c.576.577.673 1.609-.033 2.202l-3.848 3.649-1.01-1.064 3.867-3.667a.72.72 0 0 1 .02-.019.114.114 0 0 0-.03-.06Z",
    fill: "#121619"
  })));
};
export default SvgIconOutputLight;